import apiClient from "@/api/client";
import { uploadManagedFile } from "@/utils/managedFile";

export interface ManagedFileBrief {
  id: string;
  original_filename: string;
  content_type: string;
  size_bytes: number | null;
  url: string | null;
}

export interface ContractScanInfo {
  id: string;
  url: string;
  original_filename: string;
  size_bytes: number | null;
  uploaded_at: string | null;
}

export const contractScansApi = {
  // Two-step upload: push the raw PDF to the central file registry, then
  // reference the returned ManagedFile id when attaching it to a contract.
  uploadPdf: (file: File) => uploadManagedFile<ManagedFileBrief>(file),

  // Main (primary) contract scan lives on the user record.
  setUserContractScan: (userId: string, fileId: string) =>
    apiClient
      .put(`/auth/users/${userId}/contract-scan/`, { file_id: fileId })
      .then((r) => r.data.data),

  removeUserContractScan: (userId: string) =>
    apiClient.delete(`/auth/users/${userId}/contract-scan/`).then((r) => r.data.data),
};
